export default {
  ing: [
    {
      label: 'Market Leaders - Netherlands',
      value: 'Market Leaders - Netherlands',
    },
    {
      label: 'Market Leaders - Belgium/Luxembourg',
      value: 'Market Leaders - Belgium/Luxembourg',
    },
    {
      label: 'C&G - Retail',
      value: 'C&G - Retail',
    },
    {
      label: 'C&G - SME',
      value: 'C&G - SME',
    },
    {
      label: 'C&G - Other',
      value: 'C&G - Other',
    },
    {
      label: 'CSD - Risk',
      value: 'CSD - Risk',
    },
    {
      label: 'CSD - Finance',
      value: 'CSD - Finance',
    },
    {
      label: 'CSD - HR',
      value: 'CSD - HR',
    },
    {
      label: 'CSD - Other (incl. Strategy, Audit, Comms, Legal, Innovation) Wholesale Banking (WB)',
      value: 'CSD - Other (incl. Strategy, Audit, Comms, Legal, Innovation) Wholesale Banking (WB)',
    },
    {
      label: 'COO - COO',
      value: 'COO - COO',
    },
    {
      label: 'COO - Tech',
      value: 'COO - Tech',
    },
  ],
};
